import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'
import type User from 'modules/core/store/models/User'

import accessGroupMemberships from 'modules/dashboard/store/collections/AccessGroupMemberships'
import type AccessGroupMembership from 'modules/dashboard/store/models/AccessGroupMembership'

const Strategies = {
  self: 'self',
  manager: 'manager',
  reportees: 'reportees',
  peers: 'peers',
  everyone: 'everyone',
  active: 'active',
  withRegularAccess: 'withregularaccess',
  employees: 'employees',
  members: 'members',
  groupable: 'groupable',
  groupableActive: 'groupableactive',
  groupableWithRegularAccess: 'groupablewithregularaccess',
  fql: 'fql',
}

const GroupableTypes = {
  location: 'Location',
  team: 'Team',
  legalEntity: 'LegalEntity',
}

const QueryId = {
  fqlLegalEntity: 'fql:access:legal_entity',
  fqlLocation: 'fql:access:location',
  fqlTeam: 'fql:access:team',
}

const CompanyGroup = 'Company'

interface IAccessGroup {
  [key: string]: any
}

// FIXME: Get rid of these generic access groups as soon as dashboard stops using them
/**
 * @deprecated Do not use the generic access group model, we're removing it from the API. Create a domain specific entity instead.
 */
class AccessGroup extends Model<IAccessGroup> {
  static Strategies = Strategies
  static GroupableTypes = GroupableTypes
  static CompanyGroup = CompanyGroup
  static QueryId = QueryId

  constructor(attr: IAccessGroup = {}) {
    super(attr)
    makeObservable(this, {
      memberships: computed,
    })
  }

  static urlRoot() {
    return '/access_groups'
  }

  get memberships(): AccessGroupMembership[] {
    return accessGroupMemberships.filter({
      access_group_id: this.attributes.id,
    })
  }

  get query_id(): string {
    return this.attributes.query_id
  }

  isMember(user: User): boolean {
    return Boolean(
      accessGroupMemberships.find({
        access_group_id: this.attributes.id,
        access_id: user.attributes.id,
      })
    )
  }

  async update(_attributes: unknown, _saveOptions: unknown = {}) {
    throw new Error("Can't modify generic access groups through the API")
  }

  async save(_attributes: unknown, _saveOptions: unknown = {}) {
    throw new Error("Can't modify generic access groups through the API")
  }

  async delete(_destroyOptions: unknown) {
    throw new Error("Can't modify generic access groups through the API")
  }

  async destroy(_destroyOptions: unknown) {
    throw new Error("Can't modify generic access groups through the API")
  }

  rpc(_endpoint: unknown, _options: unknown): Promise<never> {
    throw new Error("Can't modify generic access groups through the API")
  }
}

export default AccessGroup
